import {
  STATUSES,
  makePaginationState,
  makeListState,
  concatUnique,
} from 'app/utils/redux';

import { MARKET_ITEM_TYPES } from 'app/utils/constants';

import * as t from './types';


const initialMarketItems = Object.keys(MARKET_ITEM_TYPES)
  .reduce((acc, type) => {
    const key = MARKET_ITEM_TYPES[type].type;
    acc[key] = makePaginationState();
    return acc;
  }, {});

const initialState = {
  marketItems: initialMarketItems,
  inventories: makeListState(),
  curations: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_MARKET_ITEMS}_PENDING`: {
      const { type } = action.meta;
      return {
        ...state,
        marketItems: {
          ...state.marketItems,
          [type]: {
            ...state.marketItems[type],
            status: STATUSES.PENDING,
          },
        },
      };
    }
    case `${t.FETCH_MARKET_ITEMS}_SUCCESS`: {
      const { type } = action.meta;
      return {
        ...state,
        marketItems: {
          ...state.marketItems,
          [type]: {
            status: STATUSES.SUCCESS,
            isLoaded: true,
            pagination: {
              ...action.payload.result,
              items: concatUnique(
                state.marketItems[type].pagination.items,
                action.payload.result.items,
              ),
            },
          },
        },
      };
    }
    case `${t.FETCH_MARKET_ITEMS}_ERROR`: {
      const { type } = action.meta;
      return {
        ...state,
        marketItems: {
          ...state.marketItems,
          [type]: {
            ...state.marketItems[type],
            status: STATUSES.ERROR,
          },
        },
      };
    }

    // my market inventories
    case `${t.FETCH_MY_MARKET_INVENTORIES}_PENDING`:
      return {
        ...state,
        inventories: {
          ...state.inventories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_MARKET_INVENTORIES}_SUCCESS`:
      return {
        ...state,
        inventories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_MY_MARKET_INVENTORIES}_ERROR`:
      return {
        ...state,
        inventories: {
          ...state.inventories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.USE_MARKET_INVENTORY}_SUCCESS`: {
      const { id, type } = action.meta;
      if (type === null) {
        return { ...state };
      }

      return {
        ...state,
        inventories: {
          ...state.inventories,
          list: state.inventories.list
            .map((inventory) => {
              const {
                status,
                marketItem,
              } = inventory;

              if (type !== marketItem.type) {
                return inventory;
              }

              if (id === inventory.id) {
                return {
                  ...inventory,
                  status: status === 'INACTIVE' ? 'ACTIVE' : 'INACTIVE',
                };
              }

              return {
                ...inventory,
                status: 'INACTIVE',
              };
            }),
        },
      };
    }
    case `${t.USE_MARKET_INVENTORY}_ERROR`: {
      const now = new Date();

      return {
        ...state,
        inventories: {
          ...state.inventories,
          list: state.inventories.list
            .filter((inventory) => {
              if (now > new Date(inventory.expired)) {
                return false;
              }

              return inventory.id !== action.meta.id;
            }),
        },
      };
    }

    case t.REMOVE_OPTION: {
      const { itemId, optionId, type } = action.meta;

      const mapFunction = (item) => {
        if (item.id === itemId) {
          return {
            ...item,
            options: item.options.filter(option => option.id !== optionId),
          };
        }

        return item;
      };

      if (type === 'curation') {
        return {
          ...state,
          curations: {
            ...state.curations,
            list: state.curations.list.map(curation => ({
              ...curation,
              items: curation.items.map(mapFunction),
            })),
          },
        };
      }

      return {
        ...state,
        marketItems: {
          ...state.marketItems,
          [type]: {
            ...state.marketItems[type],
            pagination: {
              ...state.marketItems[type].pagination,
              items: state.marketItems[type].pagination.items
                .map(mapFunction),
            },
          },
        },
      };
    }

    // market curations
    case `${t.FETCH_MARKET_CURATIONS}_PENDING`:
      return {
        ...state,
        curations: {
          ...state.curations,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MARKET_CURATIONS}_SUCCESS`:
      return {
        ...state,
        curations: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_MARKET_CURATIONS}_ERROR`:
      return {
        ...state,
        curations: {
          ...state.curations,
          status: STATUSES.ERROR,
        },
      };

    case `${t.PURCHASE_MARKET_ITEM}_SUCCESS`: {
      const inventory = action.payload.result;

      return {
        ...state,
        inventories: {
          ...state.inventories,
          list: [inventory].concat(state.inventories.list
            .filter(i => i.marketItem.id !== inventory.marketItem.id)),
        },
      };
    }

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/market/reducer.js